var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings"},[_c('pre',[_vm._v("\t\tTODO: implement M1\n\t")])])
}]

export { render, staticRenderFns }